import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { TextBlock } from "graphql/types"
import { useState } from "react"

type AddBlockToChapterProps = {
  textBlocks: TextBlock[]
  open: boolean
  onClose: () => void
  onSave: (block: TextBlock) => void
}

export const AddBlockToChapter = (props: AddBlockToChapterProps) => {
  const { open, onClose, onSave, textBlocks } = props
  const [block, setBlock] = useState<TextBlock | null>(null)

  const handleSave = () => {
    if (block) {
      onSave(block)
    }
    onClose()
    setBlock(null)
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={open}>
      <DialogTitle>Textvorlage auswählen und hinzufügen</DialogTitle>
      <DialogContent>
        <Autocomplete
          options={textBlocks}
          value={block}
          onChange={(_, value) => setBlock(value)}
          getOptionLabel={(option) => option.name || ""}
          renderInput={(params) => <TextField {...params} label="Textblock auswählen" />}
        />
      </DialogContent>
      <DialogActions>
        <StyledButton buttonType="cancel" onClick={onClose} />
        <StyledButton buttonType="save" onClick={handleSave} />
      </DialogActions>
    </Dialog>
  )
}
